var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecycleBin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 4.16675L3.87169 13.3133C3.97563 15.0803 4.0276 15.9638 4.40472 16.6342C4.73671 17.2245 5.24059 17.6996 5.84929 17.9963C6.54075 18.3334 7.42578 18.3334 9.19582 18.3334H10.8048C12.5749 18.3334 13.4599 18.3334 14.1514 17.9963C14.7601 17.6996 15.2639 17.2245 15.5959 16.6342C15.9731 15.9638 16.025 15.0803 16.129 13.3133L16.667 4.16675M3.33366 4.16675H1.66699M3.33366 4.16675H16.667M16.667 4.16675H18.3337M8.33366 8.33342V14.1667M11.667 8.33342V11.6667M13.3337 4.16675L12.9562 3.03429C12.7923 2.54253 12.7103 2.29665 12.5583 2.11486C12.424 1.95433 12.2516 1.83007 12.0569 1.75348C11.8364 1.66675 11.5772 1.66675 11.0588 1.66675H8.94184C8.42348 1.66675 8.1643 1.66675 7.94377 1.75348C7.74902 1.83007 7.57663 1.95433 7.44238 2.11486C7.29036 2.29665 7.2084 2.54253 7.04448 3.03429L6.66699 4.16675",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecycleBin);
export default ForwardRef;